import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../service/auth/auth.service';
import { ElMessageService } from 'element-angular';
import { CompanySettingService } from '../service/company-setting/company-setting.service';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(
    public router: Router,
    public authService: AuthService,
    private message: ElMessageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // 如果已经登录
    if (this.authService.isLoggedIn) {
      // 如果访问样版模块
      if (state && state.url && state.url.startsWith('/workspace/company-specimen')) {
        if ((this.authService.employer || this.authService.adminSpecimenReading || this.authService.adminSpecimen || this.authService.adminSpecimenAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/company-order')) {
        if ((this.authService.employer || this.authService.adminTradeOrderReading || this.authService.adminTradeOrder || this.authService.adminTradeOrderAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/company-purchase')) {
        if ((this.authService.employer || this.authService.adminPurchaseOrderReading || this.authService.adminPurchaseOrder || this.authService.adminPurchaseOrderAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/company-task')) {
        if ((this.authService.employer || this.authService.adminCompanyTaskReading || this.authService.adminWorkstage || this.authService.adminBundle || this.authService.adminProductionData || this.authService.adminSchedule || this.authService.adminBatchDailyWork || this.authService.adminCompanyTask || this.authService.adminCompanyTaskAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/company-salary')) {
        if ((this.authService.employer || this.authService.adminStaffsReading || this.authService.adminStaffs || this.authService.adminStaffsAuditing || this.authService.adminCompanySalaryReading || this.authService.adminCompanySalary || this.authService.adminCompanySalaryAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/company-auditing')) {
        if ((this.authService.employer || this.authService.adminAuditingReading || this.authService.adminAuditing || this.authService.adminSpecimenAuditing || this.authService.adminTradeOrderAuditing || this.authService.adminPurchaseOrderAuditing || this.authService.adminCompanyTaskAuditing || this.authService.adminStaffsAuditing || this.authService.adminCompanySalaryAuditing || this.authService.adminRecordStockAuditing || this.authService.adminCustomerBillsAuditing || this.authService.adminRevenueAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/warehouse-management')) {
        if ((this.authService.employer || this.authService.adminRecordStockReading || this.authService.adminRecordStock || this.authService.adminRecordStockAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/customer-bill')) {
        if ((this.authService.employer || this.authService.adminCustomerBillsReading || this.authService.adminCustomerBills || this.authService.adminCustomerBillsAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else if (state && state.url && state.url.startsWith('/workspace/revenue')) {
        if ((this.authService.employer || this.authService.adminRevenueReading || this.authService.adminRevenue || this.authService.adminRevenueAuditing) && this.computerAccess()) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      this.verifyToken();
      return false;
    }
  }

  computerAccess() {
    // 企业主访问
    if (this.authService.employer) {
      return true;
    } else if (!this.authService.userInfo.computerAccess || this.authService.userInfo.computerAccess === 'yes' || (this.authService.userInfo.computerAccess === 'some' && localStorage.getItem(`${this.authService.userInfo.id}`) === '1')) {
      // 员工访问
      return true;
    } else {
      this.message.setOptions({
        center: true,
        zIndex: 9999
      });
      this.message['error']('您被【禁止在该电脑查看企业数据】，如有疑问，请联系您公司的管理员');
      return false;
    }
  }

  // 浏览器刷新，自动登录，等上线后再测试
  verifyToken() {
    // 如果是已登录状态，则不需要执行 "自动登录"
    if (this.authService.isLoggedIn) {
      return true;
    }
    const accesstoken = sessionStorage.getItem('AccessToken');
    if (!accesstoken) {
      return false;
    }
    const data = {
      accesstoken: accesstoken
    };
    // subscribe的三个回调函数和顺序：next , error, complete
    this.authService.verifyToken(data).subscribe((response) => {
      if (response.result) {
        // 登录成功
        this.authService.accesstoken = accesstoken;
        this.authService.isLoggedIn = true;
        this.authService.userInfo = response.result;
        if (this.authService.userInfo.roleID) {
          // 当前用户，已经赋予 "职位"
          for (let i = 0; this.authService.roleList && i < this.authService.roleList.length; i++) {
            if (this.authService.roleList[i].roleID === this.authService.userInfo.roleID) {
              this.authService.tabShow(this.authService.roleList[i].permission);
              break;
            }
          }
        }
        if (this.authService.userInfo.identity === 'company') {
          // 老板登录
          this.authService.employer = true;
        }
        this.router.navigateByUrl('/workspace');
        // if (this.authService.userInfo.identity === 'company' || (this.authService.userInfo.identity === 'employee' && this.authService.userInfo.state === 2)) {
        //   // 老板或管理员登录
        //   this.router.navigateByUrl('/workspace');
        // } else {
        //   // 普通员工登录
        //   this.router.navigateByUrl('/workspace/employee/home');
        // }
      } else {
        this.authService.isLoggedIn = false;
        this.router.navigateByUrl('landing-page');
      }
    }, error => {
      // this.authService.loadImageShow = true;
      // setTimeout(() => {
      //   this.message.setOptions({
      //     center: true,
      //     zIndex: 9999
      //   });
      //   this.message['warning']('网络错误，请稍后重试');
      //   this.authService.loadImageShow = false;
      // }, 10000);
      this.authService.isLoggedIn = false;
      this.router.navigateByUrl('landing-page');
    });
  }
}
